import React from 'react'
import styles from './StatsCard.module.css'

const StatsCard = ({ title, value, color, icon, onClick }) => {
  return (
    <button type="button" className={styles.statsCard} onClick={onClick}>
      <div className={styles.statsContent}>
        <div className={styles.statsInfo}>
          <p className={styles.statsTitle}>{title}</p>
          <h3 className={styles.statsValue}>{value}</h3>
        </div>
        <div 
          className={styles.statsIcon}
          style={{ backgroundColor: color }}
        >
          {icon}
        </div>
      </div>
    </button>
  )
}

export default StatsCard